<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <div class="searchItem">
                            <el-input v-model="name" placeholder="名称"></el-input>
                        </div>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" @click="toDialog('add','')"><i
                                    class="el-icon-circle-plus-outline"></i>新增
                                </el-button>
                            </div>
                        </div>
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="name"
                                label="名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                align="center"
                                header-align="center"
                                label="创建时间">
                            </el-table-column>
                            <el-table-column
                                prop="content"
                                align="center"
                                header-align="center"
                                label="描述">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="toDialog('edit',scope.row.uuid)">编辑</el-button>
                                    <el-button type="text" size="small" @click="removeTemplate(scope.row.uuid)">删除</el-button>
                                    <el-button type="text" size="small" @click="viewTemplate(scope.row.uuid)">查看</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- 新增/编辑 -->
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="1000px" :close-on-click-modal="false">
            <div class="dialogContent">
                <el-form :model="form" ref="ruleForm" label-width="120px">
                    <el-form-item label="模板名称" prop="name">
                        <el-input v-model="form.name" placeholder="模板名称"></el-input>
                    </el-form-item>
                    <el-form-item label="描述" prop="content">
                        <el-input type="textarea" v-model="form.content" placeholder="描述"></el-input>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <!-- 查看 -->
        <el-dialog
            title="查看"
            :visible.sync="viewDialogVisible"
            width="1000px" :close-on-click-modal="false">
            <div class="examine">
                <h2>模板信息</h2>
                <div class="examineList">
                    <p>模板名称 :</p>
                    <p>{{ form.name }}</p>
                </div>
                <div class="examineList">
                    <p>描述 :</p>
                    <p>{{ form.content }}</p>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { getTemplateList, saveTemplateInfo, findTemplateInfo, updateTemplateInfo, deleteTemplateInfo } from '../../utils/interface';
export default {
    data() {
        return {
            name: '',
            tableData: [],
            current: 1,
            pageSize: 10,
            total: 0,
            // 新增-编辑
            dialogVisible:false,
            title:"",
            form:{
                uuid:'',
                name:'',
                content:''
            },
            // 查看
            viewDialogVisible:false,
        }
    },
    computed: {
        contentViewHeight() {
            let height = document.documentElement.clientHeight - 120
            return {minHeight: height + 'px'}
        },
    },
    created() {
        this.getList();
    },
    methods: {
        getList(){
            let params = {
                name:this.name,
                current:this.current,
                pageSize:this.pageSize,
            }
            getTemplateList(params).then((res)=>{
                this.total = res.total;
                this.tableData = res.list;
            });
        },
        resetData(){
            this.name = '';
            this.getList();
        },
        // 分页
        handleCurrentChange(val){
            this.current = val;
            this.getList();
        },
        search(){
            this.current = 1;
            this.getList();
        },
        successList(){
            this.current = 1;
            this.getList();
        },
        // 新增
        toDialog(type,uuid){
            this.resetFormData();
            if(type=='add'){
                this.title = '新增';
            }else if(type=='edit'){
                this.title = '编辑';
                findTemplateInfo(uuid).then((res)=>{
                    if(res.success){
                        this.form = res.data;
                    }
                });
            }
            this.dialogVisible = true;
        },
        resetFormData(){
          this.form = {
              uuid:'',
              name:'',
              content:'',
          }
        },
        submit(){
            if(this.form.uuid!=''){
                updateTemplateInfo(this.form).then((res)=>{
                    if(res.success){
                        this.$message.success("保存成功");
                        this.getList();
                    }else{
                        this.$message.error(res.message);
                    }
                });
            }else{
                saveTemplateInfo(this.form).then((res)=>{
                    if(res.success){
                        this.$message.success("编辑成功");
                        this.getList();
                    }else{
                        this.$message.error(res.message);
                    }
                });
            }
            this.dialogVisible = false;
        },
        // 删除
        removeTemplate(uuid){
            this.$confirm('确定要删除当前模板嘛？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteTemplateInfo(uuid).then((res)=>{
                    if(res.success){
                        this.$message.success("删除成功");
                        this.getList();
                    }else{
                        this.$message.error(res.message);
                    }
                });
            });
        },
        viewTemplate(uuid){
            findTemplateInfo(uuid).then((res)=>{
                if(res.success){
                    this.form = res.data;
                    this.viewDialogVisible = true;
                }
            });
        }
    }
}
</script>

<style scoped lang="less">
.orderManagementClass {
    position: relative;
    width: 100%;
    padding: 0 20px 20px;
    .orderManagementContent {
        background: #fff;
        .printOrderListBox {
            padding: 20px;
            .orderSearchBox {
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-input {
                    width: initial;
                    margin-right: 30px;
                }

                /deep/ .el-input__inner {
                    width: 242px;
                    height: 35px;
                    min-height: 35px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                    border: 1px solid #f2f4f7;
                    border-radius: 5px;

                    &:hover,
                    &:focus {
                        background-color: #fff;
                        border: 1px solid #108ee9;
                    }
                }

                /deep/ .el-input__prefix {
                    top: -3px;
                }

                /deep/ .el-input__suffix {
                    top: 2px;
                }

                /deep/ .el-button {
                    display: block;
                    line-height: 35px;
                    padding: 0;
                    height: 35px;
                }

                .searchBtn {
                    width: 82px;
                    background: #3d7fff;
                    border: none;
                    border-radius: 15px;
                    font-size: 14px;
                    color: #ffffff;
                }

                .resetBtn {
                    color: #333333;
                }
                .searchItem {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                    // margin-right: 30px;

                    .name {
                        padding-right: 20px;
                        min-width: 100px;
                    }
                }
            }

            .tableContent {
                min-height: 650px;

                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }

                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }

                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }
                }
            }

            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }
    }
    .tableTool {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        .toolRight {
            button {
                width: 83px;
                height: 30px;
                background: rgba(21, 126, 251, 1);
                border: none;
                border-radius: 15px;
                font-size: 13px;
                color: #fff;

                i {
                    padding-right: 5px;
                }

                &:hover {
                    background: #61a2f0;
                }
            }
        }
    }
    .dialogBox{
        .details{
            .detailsItem{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .itemContent{
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    .one-row{
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        .label{
                            padding-right: 15px;
                            min-width: 95px;
                        }
                        .name{
                            color: #000;
                        }
                    }
                    .two-row{
                        width: 100%;
                        margin-bottom: 22px;
                        display: flex;
                        .label{
                            padding-right: 15px;
                            min-width: 95px;
                        }
                        .name{
                            color: #000;
                        }
                    }
                }
                .itemPictureContent{
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    justify-content: space-between;
                    .one-row{
                        width: 30%;
                        margin-bottom: 22px;
                        img{
                            width: 100%;
                            height: 138px;
                            border: 1px solid #ddd;
                        }
                        .name{
                            text-align: center;
                            padding-top: 10px;
                            font-size: 14px;
                            display: flex;
                            .label{
                                min-width: 80px;
                            }
                        }
                    }
                }
            }
        }
        .audit{
            padding-bottom: 20px;
            h3{
                font-weight: 700;
                font-size: 16px;
                color: #000;
                margin-top: 0;
                letter-spacing: 1px;
                border-bottom: 1px solid #ddd;
                padding-bottom: 15px;
            }
            .auditContent{
                padding: 0 30px;
            }
            .cause{
                display: flex;
                margin-top: 20px;
                .causeTitle{
                    min-width: 80px;
                    color: #3a8ee6;
                }
                .causeContent{
                    color: #000;
                }
            }
            .auditEnter{
                text-align: center;
                padding-top: 20px;
                button{
                    width: 120px;
                }
            }
        }
    }
}
.dialogContent {
    padding: 0 5%;
    /deep/.el-upload-list--picture-card .el-upload-list__item{
        width: 590px;
        height: 300px;
    }
    /deep/.el-upload--picture-card{
        width: 590px;
        height: 300px;
        line-height: 300px;
    }
    /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail{
        width: 590px;
        height: 300px;
    }
    .thumbnailClass{
        width: 590px;
        height: 300px;
        .avatar{
            width: 590px;
            height: 300px;
            border: 1px dashed #ddd;
            border-radius: 4px;
            line-height: 300px;
            font-size: 50px;
        }
    }
    .endPeriodClass{
        /deep/.el-form-item__content{
            margin-left: 0 !important;
        }
    }
    .submitButtonClass{
        /deep/.el-form-item__content{
            margin-left: 0 !important;
            text-align: center;
            button{
                padding: 0;
                width: 120px;
                height: 35px;
                line-height: 35px;
                border-radius: 6px;
            }
        }
    }
    .modelHeightRangeClass{
        display: flex;
        margin-bottom: 25px;
        /deep/.el-form-item__content{
            margin-left: 0 !important;
        }
    }
}
.examine {
    h2 {
        font-weight: 700;
        font-size: 16px;
        color: #000;
        margin-top: 26px;
        letter-spacing: 1px;
    }
    .examineList {
        display: flex;
        // align-items: center;
        img {
            width: 300px;
            height: 150px;
        }
        p:nth-of-type(1){
            margin-right: 16px;
            width: 85px;
            flex-shrink: 0;
        }
        .examine_html {
            /deep/img {
                max-width: 100%;
            }
        }
        .logoImg {
            display: flex;
            flex-wrap: wrap;
            img {
                margin-right: 10px;
                margin-bottom: 10px;
                width: 190px;
                height: 90px;
            }
        }
        margin-top: 2px;
    }
    .examineListTwo {
        display: flex;
        align-items: center;
        .examineListTwo_box {
            display: flex;
            align-items: center;
            width: 50%;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activityTemplateList.vue